module.exports = __webpack_public_path__ + "img/sankaku_66_red.7e498aef.png";